import {utils, vh} from "./utils";

let gsapMatchmedia = gsap.matchMedia();


// Initialize a new Lenis instance for smooth scrolling
const lenis = new Lenis();

// Listen for the 'scroll' event and log the event data to the console
/*lenis.on('scroll', (e) => {
	console.log(e);
});*/

// Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
lenis.on('scroll', ScrollTrigger.update);

// Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
// This ensures Lenis's smooth scroll animation updates on each GSAP tick
gsap.ticker.add((time) => {
	lenis.raf(time * 1000); // Convert time from seconds to milliseconds
});

// Disable lag smoothing in GSAP to prevent any delay in scroll animations
gsap.ticker.lagSmoothing(0);


/**
 * Images parallax
 */
gsap.utils.toArray('.parallax-img-container').forEach(function (container) {
	const image = container.querySelector('img');

	gsap.to(image, {
		y:             () => image.offsetHeight - container.offsetHeight,
		ease:          'none',
		scrollTrigger: {
			trigger: container,
			scrub:   true,
			pin:     false,
			//markers: true,
			//invalidateOnRefresh: true
		},
	});
});


/**
 * Add close toggle with label to sub menus
 */
document.querySelectorAll('.menu-item-has-children').forEach(function (menuItem) {

	let closeMenuItem = document.createElement('li');
	closeMenuItem.classList.add('close-sub-menu', 'menu-item');
	closeMenuItem.textContent = menuItem.querySelector('a').textContent;

	menuItem.querySelector('.sub-menu').prepend(closeMenuItem);

	let menuItemParents = utils.parents(menuItem, '.menu-item-has-children');

	menuItemParents.forEach(function (el) {
		let parentLabel         = document.createElement('span');
		parentLabel.textContent = el.querySelector('a').textContent;
		closeMenuItem.prepend(parentLabel);
		parentLabel.after(' | ');
	});

	closeMenuItem.addEventListener('click', function () {
		menuItem.classList.remove('open');
	});
});


const pageTitle = document.title;
const pageUrl   = window.location.href.split('?')[0];

/**
 * Load article content when opening a news popup
 */
document.body.addEventListener('openPopup', async function (e) {
	const popup  = e.detail.popup;
	const caller = e.detail.caller;

	// change url and title in browser
	const permalink = caller.dataset.permalink;
	//const title     = popup.dataset.title;

	if (permalink !== null /*&& title !== null*/)
	{
		history.pushState('', '', permalink);
		//document.title = title;
	}

	popup.classList.add('popup--loading');

	const response = await fetch(permalink);

	if (response.ok)
	{
		const html = await response.text();

		const div     = document.createElement("div");
		div.innerHTML = html;

		const article = div.querySelector(".main-article");

		const popupBody = popup.querySelector('.popup__body');

		popupBody.appendChild(article);

		popup.classList.remove('popup--loading');

		let moduleSlideshowSwiper = new Swiper('.module-slideshow .swiper', {
			slidesPerView: 1,
			loop:          false,
			navigation:    {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination:    {
				el:           '.swiper-pagination',
				type:         'custom',
				renderCustom: function (swiper, current, total) {
					return '<span class="swiper-pagination-current">' + current.toString().padStart(2, '0') + '</span> <span class="swiper-pagination-separator"></span> <span class="swiper-pagination-total">' + total.toString().padStart(2, '0') + '</span>';
				}
			},
		});

	}
});

document.body.addEventListener('closePopup', function (e) {
	const popup = e.detail.popup;

	history.pushState('', '', pageUrl);
	//document.title = pageTitle;

	const popupBody = popup.querySelector('.popup__body');
	popupBody.querySelector('article').remove();
});


const moduleGalleriaAlternataImages = document.querySelectorAll('.module-galleria-alternata .parallax-img-container')

moduleGalleriaAlternataImages.forEach(function (el) {
	gsap.from(el, {
		y:             '200px',
		scrollTrigger: {
			trigger: el,
			start:   'top bottom',
			end:     'bottom top',
			scrub:   1,
			//markers: true
		},
	});
});


/**
 * Pin Hero brand
 * @type {Element}
 */
const heroBrand = document.querySelector('.hero-brand');

if (heroBrand !== null)
{
	gsap.to('.hero-brand__bg', {
		'--overlay-opacity': 1,
		ease:                'none',
		scrollTrigger:       {
			trigger: heroBrand,
			start:   () => 'top top',
			end:     () => '+=' + vh(150),
			scrub:   true,
			//markers:     true
		},
	});

	ScrollTrigger.create({
		trigger: heroBrand,
		pin:     '.hero-brand__bg',
		start:   () => 'top top',
		end:     () => 'bottom bottom',
		//markers:     true
	});

	gsapMatchmedia.add({
		isDesktop: '(min-width: 992px)',
		isTablet:  '(min-width: 768px) and (max-width: 991.98px)',
		isMobile:  '(max-width: 767.98px)'

	}, (context) => {

		let {isDesktop, isTablet, isMobile} = context.conditions;

		gsap.from('.hero-brand__intro', {
			scale:         isDesktop ? 0.742574 : 0.8,
			bottom:        '-54px',
			ease:          'none',
			scrollTrigger: {
				trigger: '.hero-brand__intro-wrapper',
				start:   () => 'top top',
				end:     () => '+=' + vh(150),
				pin:     true,
				scrub:   true,
				//markers: true
			},
		});
	});



}


/**
 * Change sticky image on scroll
 */
const stickyImagesSection = gsap.utils.toArray('.module-immagini-sticky');

stickyImagesSection.forEach((section) => {

	gsapMatchmedia.add({
		isDesktop: '(min-width: 992px)',
		isTablet:  '(min-width: 768px) and (max-width: 991.98px)',
		isMobile:  '(max-width: 767.98px)'

	}, (context) => {

		let {isDesktop, isTablet, isMobile} = context.conditions;

		if (isDesktop)
		{
			const stickyImagesSectionImagesWrapper = section.querySelector('.module-immagini-sticky__img-wrapper');
			const stickyImagesSectionTextWrapper   = section.querySelector('.module-immagini-sticky__text-wrapper');
			const stickyImagesSectionImages        = section.querySelectorAll('.module-immagini-sticky__img');
			const stickyImagesSectionTexts         = section.querySelectorAll('.module-immagini-sticky__text');

			// copy all images, wrap each one in a div and append them in .module-immagini-sticky__img-wrapper once
			if (!stickyImagesSectionImagesWrapper.hasChildNodes())
			{
				stickyImagesSectionImages.forEach((item) => {
					const imgDiv = document.createElement('div');
					imgDiv.appendChild(item.cloneNode(true));
					stickyImagesSectionImagesWrapper.appendChild(imgDiv);
				});
			}

			// copy all texts in .module-immagini-sticky__text-wrapper once
			if (!stickyImagesSectionTextWrapper.hasChildNodes())
			{
				stickyImagesSectionTexts.forEach((item) => {
					stickyImagesSectionTextWrapper.appendChild(item.cloneNode(true));
				});
			}

			// translate the images according to the index of the section currently in the viewport
			stickyImagesSectionTextWrapper.querySelectorAll('.module-immagini-sticky__text').forEach((item) => {

				ScrollTrigger.create({
					trigger:  item,
					start:    () => 'top 25%',
					end:      () => 'bottom 25%',
					onToggle: ({progress, direction, isActive}) => {

						if (isActive)
						{
							const index = [...item.parentNode.children].indexOf(item);

							gsap.to(stickyImagesSectionImagesWrapper.querySelectorAll(':scope > div'), {
								y:        (index * -100) + '%',
								ease:     'power2.inOut',
								duration: 0.5
							});
						}
					},
					//markers:     true
				});
			});
		}
	});

});


/**
 * Module lista alternata
 */
gsap.utils.toArray('.module-lista-alternata').forEach(function (container) {

	gsapMatchmedia.add({
		isDesktop: '(min-width: 992px)',
		isTablet:  '(min-width: 768px) and (max-width: 991.98px)',
		isMobile:  '(max-width: 767.98px)'

	}, (context) => {

		let {isDesktop, isTablet, isMobile} = context.conditions;

		// section snap
		ScrollTrigger.create({
			trigger: container,
			start:   () => 'top top',
			end:     () => 'bottom top',
			scrub:   true,
			snap:    isDesktop ? {
				// snap to most visible section
				snapTo(self) {
					if (self < 0.5)
					{
						return 0;
					}
					else
					{
						return 1;
					}
				},
				duration: 0.3,
				delay:    0,
				ease:     "power1.inOut"
			} : false,
			//markers:             true,
			//invalidateOnRefresh: true
		});


		// images parallax
		if (isDesktop)
		{
			gsap.fromTo(container.querySelector('img'),
				{
					y:    '-50%',
					ease: 'none'
				},
				{
					y:             '50%',
					ease:          'none',
					scrollTrigger: {
						trigger: container,
						start:   'top bottom',
						end:     'bottom top',
						scrub:   true,
						//markers: true,
					},
				});
		}
	});

});


/**
 * Titles letters animation
 */
let animateLettersItems = document.querySelectorAll('.animate-letters');

animateLettersItems.forEach(function (item) {
	let text = item.textContent;

	// wrap words in span tags
	item.innerHTML = text.replace(/\p{L}+/gu, '<span>$&</span>'); // matches words with any kind of letter from any language, 'g' for global, 'u' for Unicode matching

	const spans = item.querySelectorAll("span");

	spans.forEach(function (span) {
		// wrap single letters in span tags
		span.innerHTML = span.textContent.replace(/[a-zA-Z0-9òàùèéì,;.!?(){}[\]:"'’<>-]/g, '<span>$&</span>');
	});

	const innerSpans = item.querySelectorAll("span span");

	gsap.set(innerSpans, {
		y: '-100%',
	});

	gsap
		.timeline({
			scrollTrigger: {
				trigger: item,
				start:   "bottom bottom",
				//markers: true
			}
		})
		.to(innerSpans, {
			y:        0,
			duration: 0.8,
			ease:     "power2.out",
			stagger:  0.02,
			delay:    0.33
		});

});


/**
 * Buttons text animation
 */
let animateTextItems = document.querySelectorAll('.animate-text');

animateTextItems.forEach(function (item) {
	let text      = Array.from(item.childNodes);
	const wrapper = document.createElement('span');
	utils.wrapAll(text, wrapper);
	let clonedNode = wrapper.cloneNode(true);
	item.appendChild(clonedNode);

	const wrapper2 = document.createElement('span');
	utils.wrapAll([wrapper, clonedNode], wrapper2);
});


/**
 * Pin hero image
 * @type {Element}
 */
const heroImage = document.querySelector('.module-hero-immagine');

if (heroImage !== null)
{
	ScrollTrigger.create({
		trigger: heroImage,
		pin:     heroImage.querySelector('.module-hero-immagine__bg'),
		start:   () => 'top top',
		end:     () => 'bottom top',
		//markers:     true
	});

	gsap.to('.module-hero-immagine__bg', {
		'--bg-opacity': 0.5,
		ease:           'none',
		scrollTrigger:  {
			trigger: heroImage,
			start:   () => 'top top',
			end:     () => 'bottom top',
			scrub:   true,
			//markers:     true
		},
	});

}



/**
 * ON LOAD
 */

window.addEventListener('load', function (event) {

	ScrollTrigger.getAll().forEach(t => t.refresh());

});



/**
 * ON RESIZE
 */

let prevWindowWidth = window.innerWidth;

window.addEventListener('resize', function (event) {
	if (event.target === window)
	{
		// trigger resizeEnd event only when the window resizing ends
		if (this.resizeTO)
		{
			clearTimeout(this.resizeTO);
		}
		this.resizeTO = setTimeout(function () {
			const event = new CustomEvent('resizeEnd');
			window.dispatchEvent(event);

			const windowWidth = window.innerWidth;

			if (windowWidth !== prevWindowWidth)
			{
				prevWindowWidth = windowWidth;

				const eventH = new CustomEvent('resizeHorizontallyEnd');
				window.dispatchEvent(eventH);
			}
		}, 200);
	}
});



/**
 * ON RESIZE END
 */

// do something when the window resizing ends
window.addEventListener('resizeEnd', function () {

	//ScrollTrigger.getAll().forEach(t => t.refresh());

});

window.addEventListener('resizeHorizontallyEnd', function () {

	ScrollTrigger.getAll().forEach(t => t.refresh());

});


/**
 * ON SCROLL
 */
/*window.addEventListener('scroll', function() {
});*/